import { date } from "@crehana/utils";
import { DefaultConditionalTypesEnum } from "../../conditional-select/index.js";
import { TCustomFieldTypeEnum } from "../types.js";
import { getCategory, getFormType } from "../utils.js";
const getDefaultInputValue = (defaultValue, formType)=>{
    if (!defaultValue || !formType || [
        TCustomFieldTypeEnum.Multiple,
        TCustomFieldTypeEnum.Date
    ].includes(formType)) return;
    if (formType === TCustomFieldTypeEnum.Number && defaultValue.values?.[0]?.operator === DefaultConditionalTypesEnum.RANGE) return defaultValue.values[0].value;
    if (formType === TCustomFieldTypeEnum.Text) return defaultValue.values?.[0]?.value[0];
    return defaultValue.values?.[0]?.value;
};
function useDefaultValues(defaultValue) {
    const defaultCategory = getCategory(defaultValue);
    const defaultFieldId = defaultValue?.fieldId;
    const defaultFieldLabel = defaultValue?.fieldLabel;
    const formType = getFormType(defaultValue);
    const defaultSelectedValues = formType === TCustomFieldTypeEnum.Multiple ? defaultValue?.values?.[0]?.value : void 0;
    const defaultInputValue = getDefaultInputValue(defaultValue, formType);
    const defaultDateValue = (()=>{
        if (formType === TCustomFieldTypeEnum.Date && defaultValue?.values?.[0]?.value) {
            const [from, to] = defaultValue.values[0].value;
            return {
                tab: to ? 'range' : 'single',
                dates: {
                    from: from ? new Date(date.format(from, 'YYYY-MM-DD', 'DD-MM-YYYY')) : void 0,
                    to: to ? new Date(date.format(to, 'YYYY-MM-DD', 'DD-MM-YYYY')) : void 0
                }
            };
        }
    })();
    const defaultConditionalType = defaultValue?.values?.[0]?.operator;
    return {
        defaultCategory,
        defaultFieldId,
        defaultFieldLabel,
        defaultSelectedValues,
        defaultInputValue,
        defaultDateValue,
        defaultConditionalType,
        defaultFormType: formType
    };
}
export { useDefaultValues };
